<template>
  <div>
    <b-row cols="12">
      <h5 class="mt-4">
        Datos del paciente
      </h5>
    </b-row>
    <b-row cols="12" class="mt-2">
      <b-col cols="3">
        <b-form-group
          id="input-group-1"
          label="Dni/Nie/Pasaporte:"
          label-for="input-reason"
        >
          <b-form-input v-model="patient.idNumber"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="9">
        <b-form-group
          id="input-group-1"
          label="Nombre completo:"
          label-for="input-reason"
        >
          <b-form-input v-model="patient.completeName"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row cols="12">
      <b-col cols="3">
        <b-form-group
          id="input-group-1"
          label="Fecha de nacimiento:"
          label-for="input-reason"
        >
          <b-form-input v-model="patient.birdDate"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="1">
        <b-form-group id="input-group-1" label="Edad:" label-for="input-reason">
          <b-form-input v-model="patient.age"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group
          id="input-group-1"
          label="Email:"
          label-for="input-reason"
        >
          <b-input-group>
            <template #append>
              <b-input-group-text
                ><b-icon icon="envelope"></b-icon
              ></b-input-group-text>
            </template>
            <b-form-input v-model="patient.email"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group
          id="input-group-1"
          label="Teléfono:"
          label-for="input-reason"
        >
          <b-input-group>
            <template #append>
              <b-input-group-text
                ><b-icon icon="telephone"></b-icon
              ></b-input-group-text>
            </template>
            <b-form-input v-model="patient.contactPhone"></b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BIcon, BIconStarFill, BIconStar, BIconStarHalf, BFormGroup, BFormTextarea, BFormInput, BButton } from 'bootstrap-vue'
export default {
  name: 'patient',
  components: {
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    BButton
  },
  props: {
  },
  data () {
    return {
      patientTypes: [
        { value: '1', text: 'Adulto' },
        { value: '2', text: 'Menor' },
        { value: '3', text: 'Lactante' }
      ],
      patient: {
        type: 1,
        idType: 'Dni',
        idNumber: '28615460X',
        completeName: 'Francisco Luis Velasco Reina',
        birdDate: '27/07/1975',
        age: '45 años',
        email: 'pacolvr@gmail.com',
        contactPhone: '656373696'
      }
    }
  },
  mounted () {
    if (sessionStorage.report) this.report = JSON.parse(sessionStorage.getItem('report'))
  },
  watch: {
    report: {
     handler (val) {
       sessionStorage.setItem('report', JSON.stringify(this.report))
     },
     deep: true
    }
  }
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// src/components/webapp/professional/patient.vue